<div  (keydown)="handleBarcodeScan($event)"></div>